<template>
  <div class="wrapper" v-if="data">
    <div class="top-wrapper">
      <div class="top-left-wrapper">
        <img :src="data.logo" class="logo" v-if="data.logo" />
        <div>{{ data.name }}</div>
      </div>
      <div class="price">{{ price | currencyFilter("$", 2) }}</div>
    </div>
    <div class="divider" />
    <div class="summary">
      {{ data.summary }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
  computed: {
    price() {
      let rv = 0;
      if (!isNaN(this.data.price)) {
        rv = Number(this.data.price);
        if (!isNaN(this.data.license)) {
          rv = rv * Number(this.data.license);
        }
      }
      return rv;
    },
  },
};
</script>

<style  scoped>
.wrapper {
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 16px;
}
.wrapper:not(:first-child) {
  margin-top: 12px;
}
.divider {
  height: 1px;
  background: #e8e8e8;
  margin: 8px 0;
}
.summary {
  font-size: 13px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #969696;
}
.top-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top-left-wrapper {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #1c1c1c;
  display: flex;
  align-items: center;
}
.logo {
  width: 32px;
  height: 32px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  margin-right: 8px;
}
.price {
  font-size: 16px;
  line-height: 24px;
  color: #969696;
}
</style>
